// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Iraq */
const IQ = /^(?:7[3-9]\d{8})$/;

export default IQ;
